import { render, staticRenderFns } from "./step-two.vue?vue&type=template&id=0b9a6920&"
import script from "./step-two.vue?vue&type=script&lang=ts&"
export * from "./step-two.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports